export const PHOTOS = {
  heroVideo: "/assets/hero-bg.mp4",
  heroVideoWebm: "/assets/hero-bg.webm",
  heroPoster: "/assets/hero-poster.jpg",
};
